import { useModalStore } from "@/stores/use-modal-store";
import { XMarkIcon } from "@heroicons/react/20/solid";
import { VisibilityIcon, ClarityIcon, DigestibilityIcon } from "@/assets/icons";
import AttentionTooltipImg from "@/assets/report-assets/attention-tooltip.png";

/*
 * AttentionTitleInfoModal component
 *
 * This modal displays information about the Attention score and its three KPIs:
 * Visibility, Clarity, and Digestibility.
 */
export const AttentionScoreInfoModal = () => {
  /* Hooks */
  const { close } = useModalStore((state) => state.modalActions);

  /* Render */
  return (
    <div className="flex flex-col gap-6">
      {/* Header */}
      <div className="flex items-center justify-center relative">
        <h2>Attention score</h2>
        <XMarkIcon onClick={close} className="size-5 cursor-pointer absolute right-0" />
      </div>

      {/* Attention tooltip image */}
      <div className="flex items-center justify-center">
        <img src={AttentionTooltipImg} alt="Attention score visualization" className="w-full  max-w-lg rounded-lg" />
      </div>

      {/* Description */}
      <p className="text-center">
        Attention measures the probability of an asset to capture viewers attention and is derived from three KPIs: Visibility, Clarity and Digestibility.
      </p>

      {/* KPI Sections */}
      <div className="flex flex-col gap-4">
        {/* Visibility */}
        <div className="p-4 bg-base-200 rounded-lg">
          <div className="flex gap-3 items-center">
            <VisibilityIcon className="size-5 flex-shrink-0" />
            <h3 className="font-semibold">Visibility</h3>
          </div>
          <p className="text-sm mt-2 opacity-70">Is the asset likely to be noticed by viewers within its target context?</p>
        </div>

        {/* Clarity */}
        <div className="p-4 bg-base-200 rounded-lg">
          <div className="flex gap-3 items-center">
            <ClarityIcon className="size-5 flex-shrink-0" />
            <h3 className="font-semibold">Clarity</h3>
          </div>
          <p className="text-sm mt-2 opacity-70">Is attention highly focused or split across many areas?</p>
        </div>

        {/* Digestibility */}
        <div className="p-4 bg-base-200 rounded-lg">
          <div className="flex gap-3 items-center">
            <DigestibilityIcon className="size-5 flex-shrink-0" />
            <h3 className="font-semibold">Digestibility</h3>
          </div>
          <p className="text-sm mt-2 opacity-70">How effectively does the design draw attention to key information?</p>
        </div>
      </div>
    </div>
  );
};
